import {ActionTree} from 'vuex'
import {AxiosError, AxiosResponse} from "axios";
import axios from "axios";

export const actions: ActionTree<any, any> = {

    updateAvatar: ({state, getters, commit, dispatch}, formdata) => {

        commit('setAvatarUpdating', true);

        return new Promise((resolve, reject) => {

            axios.post('/user/' + formdata.get('id') + '/avatar', formdata)

                .then(({data}: AxiosResponse) => {

                    commit('setUser', data.user, {root: true});
                    commit('setAvatarUpdating', false);
                    resolve(data.user);
                })
                .catch(error => {
                    commit('setAvatarUpdating', false);
                    reject(error);
                });
        });
    },

    updateUser: ({state, getters, commit, dispatch}, data) => {

        commit('setUserUpdating', true);

        return new Promise((resolve, reject) => {

            axios.put('/user/' + data.id, data)

                .then(({data}: AxiosResponse) => {

                    commit('setUser', data.user, {root: true});
                    commit('setUserUpdating', false);
                    resolve(data.user);
                })
                .catch(({response}) => {
                    commit('setUserUpdating', false);
                    reject(response);
                });
        });
    },
};
